// extracted by mini-css-extract-plugin
export var barContainer = "_2t-0";
export var extraThin = "_2t-3";
export var fillBar = "_2t-6";
export var fillContainer = "_2t-4";
export var overflow = "_2t-8";
export var overflowContainer = "_2t-5";
export var regular = "_2t-7";
export var thick = "_2t-1";
export var thin = "_2t-2";